var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    _vm.compact ? "div" : "v-card",
    {
      tag: "component",
      attrs: {
        flat: ""
      }
    },
    [
      _c(
        _vm.compact ? "div" : "gg-card-title",
        {
          tag: "component",
          staticClass: "pb-0 pt-0"
        },
        [
          _c("gg-text-field", {
            attrs: {
              "append-icon": "mdi-magnify",
              "full-width": "",
              "hide-details": "",
              clearable: "",
              placeholder: "Quick search"
            },
            on: {
              input: _vm.emitData
            },
            model: {
              value: _vm.search,
              callback: function callback($$v) {
                _vm.search = $$v
              },
              expression: "search"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }